// import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'
import ProjectPropertyOrganizations from './ProjectPropertyOrganizations.vue'
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'

export function getCustomTabsList (config) {
  const { access } = config
  return [
    {
      key: 'params',
      name: 'Основное',
      props: [
        { key: '$key', name: 'Идентификатор', _editable: false },
        { key: 'shortName', name: 'Краткое наименование', _editable: false },
        { key: 'descr', name: 'Описание', _editable: false },
        { key: 'status', name: 'Статус', _editable: false },
        { key: 'useStatus', name: 'Состояние', _editable: false },
        { key: 'startdate', name: 'Дата начала', _editable: false },
        { key: 'enddate', name: 'Дата завершения', _editable: false },
        { key: 'orderAdmittanceFoundation', name: 'Отделы, которые  могут работать по контракту', _editable: access.editPublic, component: CardPropertyObjectCustom },
        { key: 'workAreaProject', name: 'Направление работ', _editable: access.editPublic, component: CardPropertyObjectCustom },
        {
          key: 'organizationProject',
          name: 'Организация',
          type: 'objects',
          _editable: access.editOrganizationProject,
          component: ProjectPropertyOrganizations, // CardPropertyObjectTable,
          componentProps: {
            showRelationship: true,
            hideHeader: false
          }
        }
      ]
    }
  ]
}
